import { Helmet, HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import Store from "./pages/Store";
import ScrollToTop from "react-router-scroll-top";
import Download from "./pages/Download";
import Layout from "./components/Layout";
import FourOfFour from "./components/FourOfFour";

function App() {



  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          تطبيق أكواد: قائمة بأفضل أكواد الخصم للمتاجر الإلكترونية
        </title>
        <meta
          name="description"
          content="وفّر مع كل طلبية!!! قائمة أكواد متجددة لأكبر المتاجر المحلية والعالمية."
        />
        <meta
          name="keywords"
          content="كود, خصم, كوبون, عروض, خصومات, كوبونات"
        />
      </Helmet>
      <Router>
        <ScrollToTop>
          <Layout>
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/contact-us">
                <ContactUs />
              </Route>
              <Route path="/download">
                <Download />
              </Route>
              <Route path="/stores/:slug">
                <Store />
              </Route>
              <Route path="*">
                <FourOfFour />
              </Route>
            </Switch>
          </Layout>
        </ScrollToTop>
      </Router>
      {/* <ReactQueryDevtools initialIsOpen /> */}
    </HelmetProvider>
  );
}

export default App;
